import axios from "axios";

// import { setHeaderToken } from "../utils/auth";

export function forceLogout() {
  let userProfileUrl = "user/profile/seller";
  setTimeout(() => {
    axios
      .get(`${userProfileUrl}`)
      .then(function(response) {
        if (Object.keys(response.data).length === 0) {
          document.getElementById("forceLogout").click();
        }
      })
      .catch(function(response) {
        console.error(response);
      });
  }, 2000);
}

export function stringTitle(str) {
  return str.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function convert(str) {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("/");
}
